import { defineMessages } from 'react-intl'

const scope = `modules.purchasing.features.deletePODisclaimerLabel.presenters.useDeletePODisclaimerLabelPresenter`

export default defineMessages({
  confirmationModalTitle: {
    id: `${scope}.confirmationModalTitle`,
    defaultMessage: 'Delete label',
  },
  confirmationModalDescription: {
    id: `${scope}.confirmationModalDescription`,
    defaultMessage:
      'Would you like to delete the label {description}? This action cannot be undone.',
  },
  confirmationModalConfirmButton: {
    id: `${scope}.confirmationModalConfirmButton`,
    defaultMessage: 'Confirm',
  },
  confirmationModalCancelButton: {
    id: `${scope}.confirmationModalCancelButton`,
    defaultMessage: 'Cancel',
  },
  successTitle: {
    id: `${scope}.successTitle`,
    defaultMessage: 'Success',
  },
  successMessage: {
    id: `${scope}.successMessage`,
    defaultMessage: 'Label item has been deleted',
  },
  errorTitle: {
    id: `${scope}.errorTitle`,
    defaultMessage: 'Error',
  },
  defaultErrorMessage: {
    id: `${scope}.defaultErrorMessage`,
    defaultMessage: 'Failed to delete the label.',
  },
})
